const BtnLoader = () => {
  return (
    <div className="btn-loader">
      <img src={"/img/loader.png"} alt="Loading..." />
    </div>
  )
}

export default BtnLoader
